var plusProject; // eslint-disable-line no-unused-vars

Pluswerk.PlusProject.Main = function () {
  // detect invalid inputs
  $('form input, form select, form textarea').on('invalid', function () {
    $(this).closest('form').addClass('invalid');
  });

  // newsroom
  var newsrooms = $('.js-newsroom');
  for (var x = 0; x < newsrooms.length; x++) {
    new Pluswerk.MesseNewsroom.Controller.NewsController($(newsrooms[x])); // eslint-disable-line no-new
  }
  // newsroom detail page (ajax)
  var $newsroomDetails = $('.js-newsroomDetails');
  if ($newsroomDetails.length) {
    new Pluswerk.MesseNewsroom.Controller.NewsDetailsController($newsroomDetails);
  }
};

Pluswerk.PlusProject.Main.prototype = {

  // detect browsers
  detectBrowserController: new Pluswerk.PlusProject.Utility.DetectBrowserController(),

  // detect touch support
  detectTouchController: new Pluswerk.PlusProject.Utility.DetectTouchController(),

  // detect ad block
  detectAdBlockController: new Pluswerk.PlusProject.Utility.DetectAdBlockController(),

  // cookie bar
  cookieBarController: new Pluswerk.PlusProject.CookieBar.CookieBarController(),

  // Main navigation
  navigationController: new Pluswerk.PlusProject.Navigation.NavigationController(),

  // PageNavigation - several page links
  pageNavigationController: new Pluswerk.PlusProject.Navigation.PageNavigationController(),

  // FocusPoint and blur effect
  focusPointBlurController: new Pluswerk.PlusProject.Image.FocusPointBlurController(),

  // Accordion
  accordionController: new Pluswerk.PlusProject.Navigation.AccordionController(),

  // Scroll
  scrollController: new Pluswerk.PlusProject.Navigation.ScrollController(),

  // Tabs
  tabsController: new Pluswerk.PlusProject.Navigation.TabsController(),

  // Slick slider
  slickController: new Pluswerk.PlusProject.Image.SlickController(),

  // Fancybox
  fancyboxController: new Pluswerk.PlusProject.Image.FancyboxController(),

  // Form
  formController: new Pluswerk.PlusProject.Form.FormController(),

  // ImageArchive
  imageArchiveController: new Pluswerk.MesseImageArchive.Controller.ImagearchiveController(),

  // IframeResizerController
  iframeResizerController: new Pluswerk.PlusProject.Utility.IframeResizerController(),
};

plusProject = new Pluswerk.PlusProject.Main();
